import React from "react";
import InventoryRow from "./InventoryRow";

const InventoryTable = ({
  products = [],
  loading,
  fetching,
  error,
  onSaveRow,
  savingRows = {},
}) => {
  return (
    <div className="overflow-x-auto">
      {fetching && !loading && (
        <div className="mb-2 text-xs text-gray-500">
          در حال به‌روزرسانی داده‌ها...
        </div>
      )}

      <table className="min-w-full table-fixed overflow-hidden rounded-xl border border-gray-200">
        <thead className="bg-gray-100">
          <tr className="text-sm text-gray-700">
            <th className="w-16 px-3 py-3 text-right">عکس</th>
            <th className="w-80 px-3 py-3 text-right">اطلاعات کالا</th>
            <th className="w-24 px-3 py-3 text-right">قیمت (ریال)</th>
            <th className="w-20 px-3 py-3 text-right">موجودی</th>
            <th className="w-20 px-3 py-3 text-right">تخفیف (%)</th>
            <th className="w-20 px-3 py-3 text-right">حداقل سفارش</th>
            <th className="w-20 px-3 py-3 text-right">حداکثر سفارش</th>
            <th className="w-20 px-3 py-3 text-right">ضریب سفارش</th>
            <th className="w-20 px-3 py-3 text-center">وضعیت انبار</th>
            <th className="w-24 px-3 py-3 text-center">عملیات</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={10} className="py-8 text-center">
                <div className="flex items-center justify-center gap-2">
                  <div className="h-6 w-6 animate-spin rounded-full border-b-2 border-blue-500"></div>
                  <span className="text-gray-600">در حال بارگذاری کالاها...</span>
                </div>
              </td>
            </tr>
          ) : error ? (
            <tr>
              <td colSpan={10} className="py-8 text-center">
                <div className="mx-auto max-w-md rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">
                  خطا در دریافت اطلاعات موجودی
                </div>
              </td>
            </tr>
          ) : !products.length ? (
            <tr>
              <td colSpan={10} className="py-8 text-center text-gray-500">
                هیچ کالایی برای این انبار پیدا نشد.
              </td>
            </tr>
          ) : (
            products.map((product) => (
              <InventoryRow
                key={product.id}
                product={product}
                onSaveRow={onSaveRow}
                saving={Boolean(savingRows[product.id])}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default InventoryTable;
